import {NgModule} from '@angular/core';


import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {CountryDisplayComponent} from './country-display/country-display.component';
import {CityDisplayComponent} from './city-display/city-display.component';
import {OperatorDisplayComponent} from './operator-display/operator-display.component';
import {AirportDisplayComponent} from './airport-display/airport-display.component';
import {DateDisplayComponent} from './date-display/date-display.component';
import {TextDisplayComponent} from './text-display/text-display.component';
import {AffilieDisplayComponent} from './affilie-display/affilie-display.component';
import {DynamicDisplayDirective} from './dynamic-display.directive';
import {TooltipModule} from 'primeng/tooltip';
import {InputTextModule} from 'primeng/inputtext';
import { BooleanDisplayComponent } from './boolean-display/boolean-display.component';

const list = [
    CountryDisplayComponent,
    CityDisplayComponent,
    OperatorDisplayComponent,
    AirportDisplayComponent,
    DateDisplayComponent,
    TextDisplayComponent,
    AffilieDisplayComponent,
    DynamicDisplayDirective,
    BooleanDisplayComponent
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TooltipModule,
        InputTextModule
    ],
    declarations: [
        ...list
    ],
    exports: [
        ...list
    ]
})
export class DisplayModule { }
